module.exports = __webpack_public_path__ + "static/media/2.4baa2c30.mp3";